<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.5 16.25H35.8125L31.4719 6.48438C31.2754 6.04254 30.9551 5.66716 30.5496 5.40369C30.1442 5.14023 29.671 5.00001 29.1875 5H10.8125C10.329 5.00001 9.85581 5.14023 9.45036 5.40369C9.04491 5.66716 8.72456 6.04254 8.52813 6.48438L4.1875 16.25H2.5C2.16848 16.25 1.85054 16.3817 1.61612 16.6161C1.3817 16.8505 1.25 17.1685 1.25 17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H3.75V31.25C3.75 31.913 4.01339 32.5489 4.48223 33.0178C4.95107 33.4866 5.58696 33.75 6.25 33.75H10C10.663 33.75 11.2989 33.4866 11.7678 33.0178C12.2366 32.5489 12.5 31.913 12.5 31.25V28.75H27.5V31.25C27.5 31.913 27.7634 32.5489 28.2322 33.0178C28.7011 33.4866 29.337 33.75 30 33.75H33.75C34.413 33.75 35.0489 33.4866 35.5178 33.0178C35.9866 32.5489 36.25 31.913 36.25 31.25V18.75H37.5C37.8315 18.75 38.1495 18.6183 38.3839 18.3839C38.6183 18.1495 38.75 17.8315 38.75 17.5C38.75 17.1685 38.6183 16.8505 38.3839 16.6161C38.1495 16.3817 37.8315 16.25 37.5 16.25ZM10.8125 7.5H29.1875L33.0766 16.25H6.92344L10.8125 7.5ZM10 31.25H6.25V28.75H10V31.25ZM30 31.25V28.75H33.75V31.25H30ZM33.75 26.25H6.25V18.75H33.75V26.25ZM8.75 22.5C8.75 22.1685 8.8817 21.8505 9.11612 21.6161C9.35054 21.3817 9.66848 21.25 10 21.25H12.5C12.8315 21.25 13.1495 21.3817 13.3839 21.6161C13.6183 21.8505 13.75 22.1685 13.75 22.5C13.75 22.8315 13.6183 23.1495 13.3839 23.3839C13.1495 23.6183 12.8315 23.75 12.5 23.75H10C9.66848 23.75 9.35054 23.6183 9.11612 23.3839C8.8817 23.1495 8.75 22.8315 8.75 22.5ZM26.25 22.5C26.25 22.1685 26.3817 21.8505 26.6161 21.6161C26.8505 21.3817 27.1685 21.25 27.5 21.25H30C30.3315 21.25 30.6495 21.3817 30.8839 21.6161C31.1183 21.8505 31.25 22.1685 31.25 22.5C31.25 22.8315 31.1183 23.1495 30.8839 23.3839C30.6495 23.6183 30.3315 23.75 30 23.75H27.5C27.1685 23.75 26.8505 23.6183 26.6161 23.3839C26.3817 23.1495 26.25 22.8315 26.25 22.5Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsCar'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
